import React, { useState } from 'react';
import postIcon from './postIcon.png';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ResponsiveTableContainer = ({ children }) => (
    <div style={{ overflowX: 'auto', width: '100%', marginTop: '8px', marginBottom: '16px' }}>
        {children}
    </div>
);


const Info9 = () => {
    const [openResponse, setOpenResponse] = useState(null);

    const toggleResponse = (code) => {
        setOpenResponse(openResponse === code ? null : code);
    };

    return (
        <div style={{
            fontFamily: 'Gilroy-Light',
            lineHeight: 1.6,
            overflowX: 'auto',
            width: '100%',
            maxWidth: '100vw',  // ekranın genişliğini aşmasın
            boxSizing: 'border-box',
            padding: '0px 16px',
        }}>
            <h2 style={{ marginTop: 0 }}><strong>Authorization Id Flow</strong></h2>

            <p>
                Just take a token with client_id, client_secret credentials and customerId, then call Baas APIS.This flow is only used for Baas services. </p>


            <p>The required POST request address is as follows:</p>
            <ul>
                <li>
                    <img src={postIcon} alt="POST" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For test environment:</strong><br />
                    <code>https://apitest.albarakaturk.com.tr/ocf-auth-server/auth/oauth/token</code>
                </li>
                <li style={{ marginTop: '10px' }}>
                    <img src={postIcon} alt="POST" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For production environment:</strong><br />
                    <code>https://api.albarakaturk.com.tr/ocf-auth-server/auth/oauth/token</code>
                </li>
            </ul>

            <h3><strong>Request</strong></h3>
            <p>
                The authorization type should be selected as basic authentication. In the basic Auth, the Authorization header transmits a Base64-encoded string,
                representing your client_id and client_secret values, to the API.
            </p>

            <h4><strong>Request Body and Header Parameters</strong></h4>
            <p>Content-Type: <code>x-www-form-urlencoded</code></p>
            <ResponsiveTableContainer>
                <Table sx={{ minWidth: '100%', width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Value</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Required</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell>grant_type</StyledTableCell>
                            <StyledTableCell>A parameter in the OAuth 2.0 protocol indicating the type of authorization requested by a client.</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>authorization_id</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>scope</StyledTableCell>
                            <StyledTableCell>The group that includes the APIs you want to authorize. Please verify which scopes were activated during the application creation process. Ensure that your selection is made from the activated scopes</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>Authorized scope of Access Token</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>authorization_id</StyledTableCell>
                            <StyledTableCell>Customer ID</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>Customer id</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>sign (in Header)</StyledTableCell>
                            <StyledTableCell>Signed ("base64 encoded string"(client_id:client_secret))</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>Base64 encoded</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </ResponsiveTableContainer>

            <h3><strong>Responses</strong></h3>
            {[200].map((code) => {
                const isOpen = openResponse === code;
                let title = '', content = null;

                if (code === 200) {
                    title = '200 OK';
                    content = (
                        <>  <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: '100%', width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Access_token</StyledTableCell>
                                            <StyledTableCell>An authorized token to call Albaraka public or analytic APIs</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Token_type</StyledTableCell>
                                            <StyledTableCell>Always "bearer"</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Expires_in</StyledTableCell>
                                            <StyledTableCell>Expiration time of access_token (seconds)</StyledTableCell>
                                            <StyledTableCell>integer</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Scope</StyledTableCell>
                                            <StyledTableCell>Authorized scope of Access Token</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Sample:</h3>
                            <p>On a successful response from Authorization Server, you'll be provided an Access Token.</p>
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"access_token": "c28a9393-24ed-4bbe-b89c-c9f232e620c9",
"token_type": "bearer",
"expires_in": 356,
"scope": "baas_accounts baas_moneytransfers baas_investments baas_cancels "
}`}
                            </pre>
                        </>
                    );
                }

                return (
                    <div key={code} style={{ background: '#f9f9f9', padding: '10px', marginBottom: '10px' }}>
                        <div
                            onClick={() => toggleResponse(code)}
                            style={{ cursor: 'pointer', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between' }}
                        >
                            <span>{title}</span>
                            <span>{isOpen ? '▲' : '▼'}</span>
                        </div>
                        {isOpen && <div style={{ marginTop: '10px' }}>{content}</div>}
                    </div>
                );
            })}
        </div>
    );
};

export default Info9;